import React, { useState } from 'react';
import { TextField,Button,Box,Typography,Paper,IconButton,InputAdornment} from "@mui/material";
import LayoutLandingHeader from '../components/LayoutLandingHeader';
import LayoutLandingFooter from '../components/LayoutLandingFooter';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import GSTLoader from '../components/GSTLoader';
import LoginIcon from '@mui/icons-material/Login';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_BASE_URL;
  if (envUrl && !envUrl.includes('localhost')) {
    return envUrl;
  }
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return `${window.location.origin}/api`;
  }
  return envUrl || 'http://localhost:5000';
};

const BASE_URL = getApiBaseUrl();

const Login = () => {
  const [formData, setFormData] = useState({
    userId: '',
    password: ''
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const fetchOrders = async () => {
  try {
    const token = localStorage.getItem("token");
    const gstNumber = localStorage.getItem("gstNumber");

    const res = await axios.get(`${BASE_URL}/Order/GetAllOrders`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = res.data.data || [];
    console.log(data);
    const filtered = data.filter(o => o.GstNumber === gstNumber);
    // alert(gstNumber);
    // if (!filtered.length) {
    //   console.log("No orders found for GST");
    //   return;
    // }

    const today = new Date();
const fyValidationStartDate = new Date("2026-04-01T00:00:00"); 

// 👉 BEFORE Apr 1, 2026 → allow directly
if (today < fyValidationStartDate) {
  alert("Login Successful");
  navigate('/UserDashboard');
  return;
}

// 👉 AFTER Apr 1, 2026 → Apply FY validation
const isFYActive = (fyString) => {
  alert("Login Successful 1");
  // FY format "2026-2027"
  const [startYear, endYear] = fyString.split("-").map(x => parseInt(x));

  const fyStart = new Date(`${startYear}-04-01T00:00:00`);
  const fyEnd = new Date(`${endYear}-03-31T23:59:59`);

  return today >= fyStart && today <= fyEnd;
};

const hasActiveFinancialYear = filtered.some(order =>
  isFYActive(order.FinancialYear)
);

if (hasActiveFinancialYear) {
  navigate('/UserDashboard');
} else {
  alert("Login Failed due to Payment not done for current Financial Year.");
}

  } catch (err) {
    console.error('Error fetching orders', err);
  } finally {
  }
};


  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { userId, password } = formData;

    // if (userId === 'Admin' && password === '123') {
    //   localStorage.setItem('token', 'admin-token');
    //   localStorage.setItem('gstNumber', userId);
    //   localStorage.setItem('firmName', 'Admin');
    //   navigate('/AdminDashboard');
    //   return;
    // }

    try {
      const res = await axios.post(`${BASE_URL}/Auth/Login`, {
        gstNumber: userId,
        password: password
      });
      const { token, gstNumber, firmName } = res.data.data;
      localStorage.setItem('token', token);
      localStorage.setItem('gstNumber', gstNumber);
      localStorage.setItem('firmName', firmName);

      const data = [res.data.data] ;
      console.log(res.data.data, typeof res.data.data, Array.isArray(res.data.data));

      const filtered = data.filter(o => o.gstNumber   === gstNumber);
      console.log(filtered.length);
    //   console.log(filtered);
      if (filtered.length > 0 && gstNumber === 'Admin') {
      navigate('/AdminDashboard');
      return;
    }
    else if (filtered.length > 0 ) {
      navigate('/UserDashboard');
      return;
    }
    else if (filtered.length === 0) {
      alert("Login Failed due to invalid credentials.");
      return;
    }
    // if (filtered.length === 0 && gstNumber !== 'Admin') {
    //   alert("Login Failed due to invalid credentials.");
    //   return;
    // }
    // if (gstNumber === 'Admin') {
    //   navigate('/AdminDashboard');
    //   return;
    // }
    // else
    // {
    //   navigate('/UserDashboard');
    // }
    } catch (err) {
      console.error('Login error:', err);
      const serverMsg = err.response?.data?.message || err.message;
      alert(`Login failed: ${serverMsg}`);
    }
  };

  return (
    <GSTLoader>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          backgroundImage: 'url("Images/login.png")',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          bgcolor: '#f5f6fa',
        }}
      >
        <LayoutLandingHeader />
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 2,
          }}
        >
          <Paper elevation={4} sx={{
            p: 6,
            borderRadius: 3,
            maxWidth: 600,
            width: '100%',
            textAlign: 'center',
            backdropFilter: 'blur(5px)',
            backgroundColor: 'rgba(255,255,255,0.9)',
          }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3, color: '#003366' }}>
              Welcome Back 👋
            </Typography>
            <Typography variant="body2" sx={{ mb: 4, color: '#666' }}>
              Login to your account
            </Typography>
            <form onSubmit={handleSubmit}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <TextField
                  label="GST Number"
                  name="userId"
                  value={formData.userId}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  sx={{
                    borderRadius: 2,
                    mb: 2,
                    width: '300px'
                  }}
                />
                <TextField
                  label="Password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  value={formData.password}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  sx={{
                    borderRadius: 2,
                    mb: 4,
                    width: '300px'
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={togglePasswordVisibility} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 2 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    startIcon={<LoginIcon />}
                    sx={{
                      px: 4,
                      py: 1.5,
                      borderRadius: '30px',
                      fontSize: '1rem',
                      textTransform: 'none'
                    }}
                  >
                    Login
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    type="button"
                    startIcon={<PersonAddIcon />}
                    onClick={() => navigate('/UserRegistration')}
                    sx={{
                      px: 4,
                      py: 1.5,
                      borderRadius: '30px',
                      fontSize: '1rem',
                      textTransform: 'none'
                    }}
                  >
                    Register
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    type="button"
                    startIcon={<PersonAddIcon />}
                    onClick={() => navigate('/ForgetPassword')}
                    sx={{
                      px: 4,
                      py: 1.5,
                      borderRadius: '30px',
                      fontSize: '1rem',
                      textTransform: 'none'
                    }}
                  >
                    Forget Password
                  </Button>
                </Box>
              </Box>
            </form>
          </Paper>
        </Box>
        <LayoutLandingFooter />
      </Box>
    </GSTLoader>
  );
};

export default Login;
